<template>
  <div class="pathways__drug-card">
    <img :src="imgSrc" width="64" height="64" role="presentation" />
    <div>
      <h4 class="title is-3">{{ label }}</h4>
      <p v-if="description">{{ description }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PathwaysDrugCard',
  props: {
    imgSrc: String,
    label: String,
    description: String,
  },
};
</script>
